import { fmt1, fmtInt, fmtPct } from '@/lib/format';
import type { RegistroDiario } from '@/lib/types';
import { partReference } from './partReference';

export interface BeforePartStatsProps {
  registros?: RegistroDiario[];
  fecha: string;
  entrada: string;
  aves: number | null;
}

export function BeforePartStats({ registros, fecha, entrada, aves }: BeforePartStatsProps) {
  const reference = partReference(registros, fecha, entrada);
  const partial = reference.missing != null && reference.missing > 0;
  const percentage =
    reference.cumulative != null && aves != null && aves > 0
      ? fmtPct((reference.cumulative / aves) * 100)
      : null;

  return (
    <section className="parte-reference" aria-label="Antes de este parte">
      <h2>Antes de este parte</h2>
      <dl className="parte-reference-grid">
        <div>
          <dt>Ayer</dt>
          <dd>
            <strong>{reference.yesterday == null ? '—' : fmtInt(reference.yesterday)}</strong>
            <p className="parte-reference-caption">
              {reference.yesterday == null ? 'Sin registro' : 'bajas'}
            </p>
          </dd>
        </div>
        <div>
          <dt>Media 7 días</dt>
          <dd>
            <strong>{reference.mean == null ? '—' : fmt1(reference.mean)}</strong>
            <p className="parte-reference-caption">
              {registros == null
                ? 'Historial no disponible'
                : reference.mean == null
                  ? `${reference.count7}/7 días`
                  : 'bajas / día'}
            </p>
          </dd>
        </div>
        <div>
          <dt>Acumuladas</dt>
          <dd>
            <strong>{reference.cumulative == null ? '—' : fmtInt(reference.cumulative)}</strong>
            <p className="parte-reference-caption">
              bajas{percentage ? ` · ${percentage}` : ''}
              {partial ? ' · parcial' : ''}
            </p>
          </dd>
        </div>
      </dl>
      <p className="parte-reference-caption">
        {aves != null && aves > 0
          ? `Sobre ${fmtInt(aves)} aves asignadas`
          : 'Aves asignadas no disponibles'}
        {partial
          ? ` · ${fmtInt(reference.missing!)} ${reference.missing === 1 ? 'día' : 'días'} sin registro`
          : ''}
      </p>
    </section>
  );
}
